import React from 'react';

import MIcon from 'views/MIcon/MIcon';
import MRadio from 'views/MRadio/MRadio';

import { MRadioOption } from './MRadioGroup.model';
import classes from './MRadioGroup.module.scss';

type Props = {
  options: MRadioOption[];
  name: string;
  value: string | null;
  display?: 'col' | 'row';
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const MRadioGroupView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={`${classes['container']} ${props.display === 'col' ? classes['container--col'] : ''} ${props.className || ''}`.trim()}>
      {props.options.map((option: MRadioOption) => {
        return (
          <div key={option.id} className={classes['item']}>
            <MRadio
              checked={option.id === props.value}
              value={option.id}
              id={option.id}
              name={props.name}
              disabled={props.disabled}
              onChange={props.onChange}
            ></MRadio>
            {option.icon ? (
              <MIcon
                className={`${classes['item__icon']} ${option.id === props.value ? classes['item__icon--checked'] : ''}`.trim()}
                name={option.icon}
              ></MIcon>
            ) : null}
            <div className={classes['item__labels']}>
              <label className={`${classes['item__text']} ${props.labelClassName || ''}`.trim()}>{option.label}</label>
              {option.subtitle ? <span className={classes['item__subtitle']}>{option.subtitle}</span> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

MRadioGroupView.displayName = 'MRadioGroupView';
MRadioGroupView.defaultProps = {};

export default MRadioGroupView;
